import React, { useState, Component } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
} from '@mui/material';
import {
  Assessment as AssessmentIcon,
} from '@mui/icons-material';
import DailyLabelsReport from './DailyLabelsReport';
import TrackingIssuesReport from './TrackingIssuesReport';
import DailyErrorReport from './DailyErrorReport';

const REPORT_TYPES = {
  DAILY_LABELS: 'daily-labels',
  TRACKING_ISSUES: 'tracking-issues',
  DAILY_ERRORS: 'daily-errors',
};

// Error Boundary Component
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ p: 3 }}>
          <Alert severity="error">
            <Typography variant="h6" gutterBottom>Something went wrong</Typography>
            <Typography variant="body2">
              {this.state.error?.message || 'An unexpected error occurred'}
            </Typography>
            <Typography variant="caption" sx={{ mt: 1, display: 'block' }}>
              Please check the browser console for more details.
            </Typography>
          </Alert>
        </Box>
      );
    }

    return this.props.children;
  }
}

const Reporting = () => {
  const [selectedReport, setSelectedReport] = useState(REPORT_TYPES.DAILY_LABELS);

  return (
    <ErrorBoundary>
      <Box sx={{ p: 3 }}>
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <AssessmentIcon sx={{ mr: 2, color: 'primary.main' }} />
          <Typography variant="h4">Reporting</Typography>
        </Box>

        {/* Report Selector */}
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <FormControl fullWidth>
              <InputLabel>Select Report</InputLabel>
              <Select
                value={selectedReport}
                onChange={(e) => setSelectedReport(e.target.value)}
                label="Select Report"
              >
                <MenuItem value={REPORT_TYPES.DAILY_LABELS}>
                  Daily Labels Report
                </MenuItem>
                <MenuItem value={REPORT_TYPES.TRACKING_ISSUES}>
                  Tracking Issues Report
                </MenuItem>
                <MenuItem value={REPORT_TYPES.DAILY_ERRORS}>
                  Daily Error Report
                </MenuItem>
              </Select>
            </FormControl>
          </CardContent>
        </Card>

        {/* Report Content */}
        <ErrorBoundary>
          {selectedReport === REPORT_TYPES.DAILY_LABELS && (
            <DailyLabelsReport />
          )}
          {selectedReport === REPORT_TYPES.TRACKING_ISSUES && (
            <TrackingIssuesReport />
          )}
          {selectedReport === REPORT_TYPES.DAILY_ERRORS && (
            <DailyErrorReport />
          )}
        </ErrorBoundary>
      </Box>
    </ErrorBoundary>
  );
};

export default Reporting;

